module.exports = __webpack_public_path__ + "img/lagrowthmachine.45aa966d.svg";